module.exports = __webpack_public_path__ + "img/scan_ranking_one.9536bf83.png";